module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-right-fbc5b70a0c38f8e26cad93e4b97594ab.svg";